import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-titulo-informativo',
  templateUrl: './titulo-informativo.component.html',
  styleUrls: ['./titulo-informativo.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class TituloInformativoComponent {

  @Input() horaActual: string;
  @Input() visualizarHora: boolean;
  @Input() titulo: string;

  constructor() { }



}
